export default require('./de.json')
